module.exports = __webpack_public_path__ + "img/logo-white.0ff812d8.svg";